// CustomFontFamilyInlineTool.ts
import "./styles.css";
import { API, InlineTool } from "@editorjs/editorjs";

export class FontSize implements InlineTool {
  public static readonly CSS_CLASS = "editorjs-font-size"; // CSS class to be applied to the inline element

  public readonly api?: API;

  private font_size: any = "";

  constructor({ api }: { api?: API }) {
    this.api = api;
  }

  public static get isInline() {
    return true; // This tool is an inline tool
  }

  public static get title() {
    return "Font Size"; // Displayed in the toolbox
  }

  surround(): void {
    if (this.font_size.length == 0) {
      return;
    }

    document.execCommand(
      "fontSize",
      false,
      this.font_size == "10"
        ? "1"
        : this.font_size == "13"
        ? "2"
        : this.font_size == "16"
        ? "3"
        : this.font_size == "18"
        ? "4"
        : this.font_size == "24"
        ? "5"
        : this.font_size == "32"
        ? "6"
        : this.font_size == "48"
        ? "7"
        : "3"
    );

    // const font = document.createElement("font");
    // font.style.fontSize = this.font_size + "px";
    // font.style.lineHeight = "auto";
    // font.classList.add("ce-font-size");
    // font.appendChild(range.extractContents());
    // range.insertNode(font);
  }

  public render(): HTMLElement {
    const fontSizes = [10, 13, 16, 18, 24, 32, 48];
    // const fontFamily = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const container = document.createElement("div");
    container.classList.add("editorjs-dropdown");
    const btn = document.createElement("button");
    btn.classList.add("tools-truncate");
    btn.classList.add("editorjs-dropdown-btn");
    btn.classList.add("tools-size-truncate");
    const dropdownContent = document.createElement("div");
    dropdownContent.classList.add("editorjs-dropdown-content");

    fontSizes.map((size: any) => {
      const para = document.createElement("p");
      para.classList.add("editorjs-fontfamily-p");
      para.innerText = size;
      para.onclick = (e: any) => {
        this.font_size = e.target.innerText;
        btn.innerText = this.font_size;
        dropdownContent.classList.remove("editorjs-dropdown-content-active");
      };
      dropdownContent.appendChild(para);
    });

    container.appendChild(btn);
    container.appendChild(dropdownContent);
    btn.innerHTML = "11";
    btn.onclick = () =>
      dropdownContent.classList.toggle("editorjs-dropdown-content-active");

    return container;
  }

  static get sanitize() {
    return {
      text: {
        br: true,
      },
      span: {
        style: true,
        class: true,
        id: true,
        "data-tooltip": true,
        "data-user": true,
      },
      mark: {
        class: true,
        id: true,
      },
      font: {
        class: true,
        color: true,
        face: true,
        size: true,
        style: true,
      },
    };
  }

  checkState(): boolean {
    return true;
  }
}
